/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RedirectResponse } from './RedirectResponse';
import {
    RedirectResponseFromJSON,
    RedirectResponseFromJSONTyped,
    RedirectResponseToJSON,
} from './RedirectResponse';

/**
 * 
 * @export
 * @interface CustomAuthConnectResponseOneOf
 */
export interface CustomAuthConnectResponseOneOf {
    /**
     * 
     * @type {RedirectResponse}
     * @memberof CustomAuthConnectResponseOneOf
     */
    redirect: RedirectResponse;
}

/**
 * Check if a given object implements the CustomAuthConnectResponseOneOf interface.
 */
export function instanceOfCustomAuthConnectResponseOneOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "redirect" in value;

    return isInstance;
}

export function CustomAuthConnectResponseOneOfFromJSON(json: any): CustomAuthConnectResponseOneOf {
    return CustomAuthConnectResponseOneOfFromJSONTyped(json, false);
}

export function CustomAuthConnectResponseOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthConnectResponseOneOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirect': RedirectResponseFromJSON(json['redirect']),
    };
}

export function CustomAuthConnectResponseOneOfToJSON(value?: CustomAuthConnectResponseOneOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirect': RedirectResponseToJSON(value.redirect),
    };
}

